/* eslint-disable custom/no-nested-ternary -- Legacy. */

import { is } from '@common/is/is'

import type { TClassName, IChildrenProps } from '../definitions'

interface IProps extends IChildrenProps {
  readonly className?: TClassName
  readonly for?: string
}

/**
 * Létrehoz egy label elemet.
 * @param props - A label beállításai {@link IProps}.
 */
export default function Label (props: IProps): HTMLLabelElement {
  const additionals = is.array(props.className)
    ? props.className
    : is.string(props.className)
      ? [ props.className ]
      : []

  const cn: readonly string[] = [ 'form-label', ...additionals ]

  const label: HTMLLabelElement = (
    <label className={ cn }>
      { props.children }
    </label>
  )

  if (props.for) {
    label.htmlFor = props.for
  }

  return label
}
